import { useAttendancePageContext } from '../../Context';

const useAttendanceTitle = () => {
  const { currentScreen } = useAttendancePageContext();
  return { currentScreen };
};

export default useAttendanceTitle;
